import type { WorkflowOptions } from '../../types';
import { addScheduleWorkflow } from '../schedules/addScheduleWorkflow';
import { editScheduleWorkflow } from './editScheduleWorkflow';
import { editScheduleEntryWorkflow } from './editScheduleEntryWorkflow';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { deleteScheduleEntryWorkflow } from './deleteScheduleEntry';
import { addCarrierScheduleWorkflow } from './addCarrierScheduleWorkflow';
import { addScheduleEntryWorkflow } from './addScheduleEntryWorkflow';
import { deleteCarrierScheduleWorkflow } from './deleteCarrierScheduleWorkflow';
export const workflows: WorkflowOptions[] = [
  addScheduleWorkflow,
  editScheduleWorkflow,
  editScheduleEntryWorkflow,
  addCarrierScheduleWorkflow,
  deleteScheduleEntryWorkflow,
  deleteCarrierScheduleWorkflow,
  addScheduleEntryWorkflow,
  ...Object.values(generateAssetStatusWorkflow('schedule')),
];

export default workflows;
